import { css } from '@emotion/react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { DropzoneComponent } from '~/_shared/components/dropzone/dropzone.component';
import { validateReportTemplate } from '~/exportReport/templateLoader/exportReportTemplateUploader.helpers';
import { exportReportSetTemplate } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.actionCreators';

const dropzoneWrapperStyle = css({
  marginBottom: 10,
});

const errorStyle = css({
  color: 'red',
});

const acceptFileExtensions = ['yml', 'yaml'];

export const ExportReportTemplateUploaderComponent = () => {
  const [error, setError] = useState<string | null>(null);
  const dispatch = useDispatch();

  const onFileSelect = async (files: ReadonlyArray<File>) => {
    const file = files[0];
    if (!file) {
      return;
    }
    setError(null);

    try {
      const { parse } = await import('yaml');
      const text = await file.text();
      const parsed = parse(text);

      const validation = validateReportTemplate(parsed);
      if (!validation.isValid) {
        setError(validation.error ?? 'An error occurred validating template');
        return;
      }

      dispatch(exportReportSetTemplate(parsed));
    }
    catch (err) {
      setError('Could not parse the provided YAML file');
    }
  };

  const onFileReject = () => {
    setError('Incorrect file format');
  };

  return (
    <div css={dropzoneWrapperStyle}>
      <DropzoneComponent
        onFilesSelect={onFileSelect}
        onFilesReject={onFileReject}
        isMulti={false}
        acceptFileExtensions={acceptFileExtensions}
      />

      {error && <div css={errorStyle}>{error}</div>}
    </div>
  );
};
